import {ThemeOptions} from '@mui/material';

const fourTheme: ThemeOptions = {
    palette: {
        primary: {
            main: '#dc00ab',
            contrastText: '#FFF',
        },
        secondary: {
            main: '#F15BB5',
        },
        warning: {
            main: '#FEE440',
        },
        error: {
            main: '#b23d3d',
        },
        common: {
            white: '#FFF',
        },
    },
    shape: {
        borderRadius: 20,
    },
};

export default fourTheme;
